<template>
  <v-dialog persistent :value="isOpen" max-width="290" overlay-color="white" id="show-modal" overlay-opacity="0.8">
    <v-card class="pa-5 rounded-xl text-align-center d-flex flex-column justify-center rounded">
      <template v-if="isShowIcon">
        <img v-if="isError" :src="require(`@/assets/error-logo.webp`)" width="65px" height="65px" class="mb-3 affirmation-dialog__icon" />
        <img v-if="isWarning" :src="require(`@/assets/warning-logo.webp`)" width="65px" height="65px" class="affirmation-dialog__icon"  />
        <img v-if="isSuccess" :src="require(`@/assets/success-logo.webp`)" width="65px" height="65px" class="mb-3 affirmation-dialog__icon" />
        <img v-if="isHold" :src="require(`@/assets/onhold-logo.webp`)" width="38px" height="38px" class="mb-3 affirmation-dialog__icon" />
        <img v-if="isLinked" :src="require(`@/assets/linked-logo.webp`)" width="76px" height="76px" class="mb-3 affirmation-dialog__icon" />
        <img v-if="isNeedLinked" :src="require(`@/assets/need-linked-logo.webp`)" width="153.4px" height="142.74px" class="mb-3 affirmation-dialog__icon" />
      </template>
      <v-card-title class="text-body-1 affirmation-dialog__title justify-center pa-0 mt-0 mb-2">
        {{ title }}
      </v-card-title>

      <v-card-text class="subtitle-2 affirmation-dialog__body justify-center pa-0 mb-5">
        <template v-if="body">
          {{ body }}
        </template>
        <slot v-else name="body"></slot>
      </v-card-text>

      <v-card-actions class="pa-0">
        <div class="affirmation-dialog__yes-container" v-if="buttonText">
          <PrimaryButton @click="$emit(`okay`)" :height="45" :loading="loading">
            {{ buttonText }}
          </PrimaryButton>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.affirmation-dialog__title {
  font-weight: 600 !important;
  word-break: unset !important;
  color: var(--v-accent-text-base)
}

.affirmation-dialog__body {
  color: var(--v-body-text-base) !important;
  text-align: center;
}

.affirmation-dialog__icon {
  align-self: center
}

.affirmation-dialog__yes-container {
  width: 100%;
}

.affirmation-dialog__yes {
  height: 45px !important;

  span {
    font-weight: 600;
  }
}
</style>

<script lang="ts">
import Vue from 'vue'
import PrimaryButton from '@/components/PrimaryButton.vue'

export default Vue.extend({
  name: 'AffirmationDialog',

  props: {
    isOpen: Boolean,
    title: String,
    body: {
      type: String,
      required: false,
    },
    buttonText: {
      type: String,
    },
    isError: {
      type: Boolean,
    },
    isWarning: {
      type: Boolean,
    },
    isHold: {
      type: Boolean,
    },
    isSuccess: {
      type: Boolean,
    },
    isLinked: {
      type: Boolean,
    },
    isNeedLinked: {
      type: Boolean,
    },
    isShowIcon: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    PrimaryButton,
  },

})
</script>
